/**
 * Created by fers on 27.04.16.
 */
import React from 'react';
import PropTypes from 'prop-types';
import {fillInTemplate} from '../../../../common/util/FillInTemplate';
import {ParentTemplate} from '../../box-utils/ParentTemplate.react.js';
import {relayWrap} from '../../box-utils/ParentBox.react.js';

import {viewWithDataGetPrimaryData} from '../../box-utils/PrimaryData';
import Error from './Error.react.js';
import {sendError} from '../../../app/errorDisplayer';
import BoxDecorator from '../../box-utils/BoxDecorator.react';
import EmptyContent from './EmptyContent.react';
import PanelColumns from './PanelColumns.react';
import SafeHTML from '../../../fw/SafeHTML.react';

export function getAutoIcon(viewWithData) {
    let {entityDef, view} = viewWithData;

    if (view && view.connectedChannel && view.connectedChannel.channelDef && view.connectedChannel.channelDef.icon) {
        return view.connectedChannel.channelDef.icon;
    }

    if (view && view.connectedChannelDef && view.connectedChannelDef.icon) {
        return view.connectedChannelDef.icon;
    }


    if (view &&  view.entityViewDef && view.entityViewDef.dependsOnChannelDef && view.entityViewDef.dependsOnChannelDef.icon) {
        return view.entityViewDef.dependsOnChannelDef.icon;
    }

    if (entityDef && entityDef.inheritedIcon) {
        return entityDef.inheritedIcon;
    }

    if (entityDef && entityDef.icon) {
        return entityDef.icon;
    }
}

class HTMLTemplate extends ParentTemplate {

    static handlerName = "html-template";

    static propTypes = {
        viewWithData: PropTypes.object.isRequired,
    };

    getIcon() {
        let icon = getAutoIcon(this.props.viewWithData);

        if (icon) {
            return icon;
        }

        return "fa-list";
    }

	getServiceName() {
		let {entityDef} = this.props.viewWithData;

		if (entityDef && entityDef.name) {
			return entityDef.name;
		}
	}

	// eslint-disable-next-line max-params
    renderRow(template, entityDef, fields, row, idx) {
		let html = fillInTemplate(template, entityDef, fields, row);

		if (!html) {
			return '';
		}

        return (
            <div className="dativeryValue htmlTemplateRow">
                <SafeHTML value={fillInTemplate(template, entityDef, fields, row, this.props.isPreview)} />
            </div>
        );
    }

	// eslint-disable-next-line max-params
    renderData(template, entityDef, fields, data) {
        return (
			<PanelColumns>
                {data.map((row, idx) => {
                    return this.renderRow(template, entityDef, fields, row, idx);
                })}
			</PanelColumns>
        );
    }

    render() {
        try {
            let {view, entityDef} = this.props.viewWithData;
            let {entityViewDef} = view;

            let data = viewWithDataGetPrimaryData(this.props.viewWithData);

            let fields = entityDef.allFieldDefs.edges.map(({node}) => node);

            if (data && data.length > 0) {
                return (
                    <BoxDecorator icon={this.getIcon()} isPreview={this.props.isPreview} title={this.getServiceName()}>
                        <div className="boxSmall"><small>{this.renderData(entityViewDef['template'], entityDef, fields, data)}</small></div>
                    </BoxDecorator>
                );
            } else if (this.props.isPreview) {
                let data = [null];
                if (this.props.viewWithData.entityDef && this.props.viewWithData.entityDef.allFieldDefs) {
                    let exampleRow = {};

                    for (let field of this.props.viewWithData.entityDef.allFieldDefs.edges) {
                        if (field.node.exampleData) {
                            exampleRow[field.node.realId] = field.node.exampleData;
                        }
                    }

                    data = [
                        {
                            key: '1',
                            ...exampleRow
                        }
                    ];
                }


                return (
                    <BoxDecorator icon={this.getIcon()} isPreview={this.props.isPreview} title={this.getServiceName()}>
                        <div className="boxSmall"><small>{this.renderData(entityViewDef['template'], entityDef, fields, data)}</small></div>
                    </BoxDecorator>
                );
            } else {
                return (
                    <BoxDecorator icon={this.getIcon()} isPreview={this.props.isPreview} title={this.getServiceName()}>
                        <EmptyContent></EmptyContent>
                    </BoxDecorator>
                );
            }
        } catch (e) {
            sendError(e);
            return (<Error error={e} />);
        }
    }
}

export default relayWrap(HTMLTemplate);
